export default class Locale_PFList {
	SelectDate: string = "Select a date..";
	EnumsNotSupported: string = "Enums not supported yet..";
}